import { MCBCS030InitRequest } from 'types/MCBCS030/MCBCS030InitRequest'

const MCBCS030initialValues: MCBCS030InitRequest = {
  selectionManagementIdList: [],
  selectionFlowSettingId: '',
}
export { MCBCS030initialValues }
